/**
 * THEME JSON CONFIG CSS VARS
 * The following default component scss variables can be overwritten via theme configuration per brand.
 * If you need to add new one, please make sure to set a default value.
 * JSON Definition for Component with name "Example": testCssVar: "20px"
 * Resulting CSS var: $example-test-css-var: 20px;
 */

/* END THEME JSON CONFIG CSS VARS ******************************************************* */

:host {
  display: block;

  * {
    box-sizing: border-box;
  }
}

.#{$prefix}badge-wrapper {
  position: relative;
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 160px;

  @include for-size(desktop-or-larger) {
    width: calc((100vw - (2 * 48px) - (6 * 32px)) / 6);
  }

  @include for-size(tablet) {
    width: calc((100vw - (2 * 24px) - (6 * 24px) - 8px) / 6);
  }

  @include for-size(phoe) {
    max-width: unset;
  }

  .#{$prefix}badge-image {
    position: relative;
    width: 100%;
    max-width: 160px;

    &::after {
      @include aspect-ratio(4, 3);
    }

    img {
      position: absolute;
      width: 100%;
      height: 100%;
    }

    + .#{$prefix}badge-title-wrapper {
      margin-top: 16px;
      margin-bottom: 16px;
    }
  }

  .#{$prefix}badge-link {
    text-decoration: none;
    width: 100%;

    &:hover {
      .#{$prefix}badge-title {
        text-decoration: underline;
        text-decoration-color: v(contentColor);
      }
    }
  }

  .#{$prefix}badge-title-wrapper {
    position: relative;
    width: 100%;
    text-align: center;
    color: v(contentColor);
    overflow-wrap: break-word;
    @include eon-typography(copy);

    @include for-size(tablet) {
      @include eon-typography(copy-small);
    }

    @include for-size(phone) {
      @include eon-typography(copy-small);
    }
  }
}
